<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/posorderinquiry/select"
      :show="false"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      downloadPower="/posorderinquiry/PeopleExport"
      :showDownloadPower="true"
      @down="down"
      showDownloadPowerType="warning"
    >
      <el-form-item label="SN号">
        <el-input
          v-model="formModel.sn"
          maxlength="50"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="原代理商ID">
        <el-input
          v-model="formModel.sourceId"
          maxlength="50"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="目标代理商ID">
        <el-input
          v-model="formModel.targetId"
          maxlength="50"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="原代理商手机号">
        <el-input
          v-model="formModel.sourcePhone"
          maxlength="50"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="目标代理商手机号">
        <el-input
          v-model="formModel.targetPhone"
          maxlength="50"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="硬件产品种类">
        <el-select v-model="formModel.hardwareType">
          <el-option
            v-for="item in hardwareTypeStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作系统">
        <el-select v-model="formModel.optSystem">
          <el-option
            v-for="item in optSystem"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="方向">
        <el-select v-model="formModel.directionType">
          <el-option
            v-for="item in directionType"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作时间">
        <el-date-picker
          v-model="formModel.activeTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        fixed="left"
        prop="sn"
        label="SN号"
        min-width="280"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="hardwareType"
        label="硬件产品种类"
        min-width="200"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="sourceId"
        label="原代理商ID"
        :formatter="formatterTableData"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sourceName"
        label="原代理商姓名"
        :formatter="formatterTableData"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sourcePhone"
        label="原代理商手机号"
        :formatter="formatterTableData"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="targetId"
        label="目标代理商ID"
        min-width="200"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="targetName"
        label="目标代理商姓名"
        min-width="200"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="targetPhone"
        label="目标代理商手机号"
        min-width="200"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="transNumber"
        label="划拨数量"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="optSystem"
        label="操作系统"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          {{
            scope.row.optSystem == "1"
              ? "系统划拨"
              : scope.row.optSystem == "2"
              ? "代理商划拨"
              : "--"
          }}
        </template></el-table-column
      >
      <el-table-column
        prop="remark"
        label="备注"
        min-width="260"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="modifier"
        label="操作人"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="optTime"
        label="操作时间"
        min-width="280"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import PosService from "service/PosService";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "postransferinfo",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        sn: "",
        phone: "",
        orderNo: "",
        sourceId: "",
        targetId: "",
        hardwareType: "",
        activeTime: "",
        optSystem: "",
        directionType: "",
      },
      tableData: [],
      hardwareTypeStatus: [{ id: "", name: "全部" }],
      optSystem: [
        {
          id: "",
          name: "全部",
        },
        {
          id: "1",
          name: "系统划拨",
        },
        {
          id: "2",
          name: "代理商划拨",
        },
      ],
      directionType: [
        {
          id: "",
          name: "全部",
        },
        {
          id: "1",
          name: "入库",
        },
        {
          id: "2",
          name: "出库",
        },
      ],
      submitService: PosService.postransferinfoList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (
        this.formModel.activeTime == null ||
        this.formModel.activeTime == ""
      ) {
        this.formModel.activeTime = [];
      }
      this.params = {
        sn: this.formModel.sn,
        sourcePhone: this.formModel.sourcePhone,
        targetPhone: this.formModel.targetPhone,
        orderNo: this.formModel.orderNo,
        sourceId: this.formModel.sourceId,
        targetId: this.formModel.targetId,
        hardwareType: this.formModel.hardwareType,
        optSystem: this.formModel.optSystem,
        directionType: this.formModel.directionType,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.activeTime.length) {
        this.params.startTime = this.formModel.activeTime[0];
        this.params.endTime = this.formModel.activeTime[1];
      }
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        hardwareType: "",
        activeTime: "",
        optSystem: "",
        directionType: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.gethardwareTypeStatus();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    gethardwareTypeStatus() {
      //硬件产品类型
      this.doLoad(
        PosService.posYingJianType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.hardwareTypeStatus = [
              ...this.hardwareTypeStatus,
              ...res.contents,
            ];
          });
        },
        "信息获取失败"
      );
    },
    down() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "export",
            "8885",
            "/machines/t-machines-transfer-dtl/"
          )
        : "";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/PosImplement/PosTransferInfo.vue